import { authObservable } from 'infra/observers/auth';

const responseCodeException = (code?: string) => {
	switch (code) {
		case 'company.invalid.token':
			authObservable.invalidToken();
			break;
		case 'company_watcher.token.invalid':
			authObservable.companyWatcherInvalidToken();
			break;

		default:
			break;
	}
};

export { responseCodeException };
